import { render, staticRenderFns } from "./risks.vue?vue&type=template&id=4462b443"
import script from "./risks.vue?vue&type=script&lang=js"
export * from "./risks.vue?vue&type=script&lang=js"
import style0 from "./risks.vue?vue&type=style&index=0&id=4462b443&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports